import { CompanyCapitalType } from '@blockpulse3/graphql/hooks';

import { CapitalTypeIntl } from './types';

export const capitalTypeOptions: { label: CapitalTypeIntl; value: CompanyCapitalType }[] = [
  { label: 'FIXED', value: CompanyCapitalType.FIXED },
  { label: 'VARIABLE', value: CompanyCapitalType.VARIABLE },
];
